import React from 'react';
import Header from "../Header";
import Footer from "../Footer";
import MapSection from "../MapSection"


const Map = () => {
    return (
        <div>
            <Header/>
            <MapSection/>
            <Footer/>
        </div>
    );
};

export default Map;